import React, {useState, Fragment} from "react"

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import moment from "moment"
import MomentUtils  from '@date-io/moment';
import "moment/locale/it"

moment.locale('it');

class LocalizedUtils extends MomentUtils {
    getDatePickerHeaderText(date) {
        return this.format(date, "D MMMM Y", { locale: this.locale });
    }
}

const AddDialog = (props) => {

    const defaultState = {
        nome: '',
        cognome: '',
        giaSocio: false,
        socio2020: false,
        dataNascita: null,
        luogoNascita: '',
        indirizzo: '',
        citta: '',
        email: ''
    }

    const [stato, setStato] = useState(defaultState)

    const updateField = e => {
        setStato({
            ...stato,
            [e.target.name]: e.target.value
        });
    };
    const updateCheckbox = e => {
        setStato({
            ...stato,
            [e.target.name]: e.target.checked
        });
    };

    const handleDateChange = (date) => {
        setStato({
            ...stato,
            'dataNascita': date
        });
    }

    const salva = (e) => {
        e.preventDefault();
        props.save(stato);
        setStato(defaultState);
        return false;
    }

    return(<Dialog open={props.open}>
        <form id={"persona"} onSubmit={salva}>
        <DialogTitle>Aggiungi nominativo</DialogTitle>
        <DialogContent>
            <TextField name={"nome"} label={"Nome"} value={stato.nome} fullWidth={true} required={true}  onChange={updateField}/>
            <TextField name={"cognome"} label={"Cognome"} value={stato.cognome} fullWidth={true} required={true}  onChange={updateField}/>
            <FormControl style={{marginTop: '16px'}}>
                <FormControlLabel label={"Ha già rinnovato la tessera Kinoglaz per l'anno 2020"} control={
                    <Checkbox name={"socio2020"} checked={stato.socio2020} onChange={updateCheckbox}/>
                }/>
            </FormControl>
            {(!stato.socio2020) && <FormControl>
                <FormControlLabel label={"È già stato/a socio/a Kinoglaz negli ultimi anni"} control={
                <Checkbox name={"giaSocio"} checked={stato.giaSocio} onChange={updateCheckbox}/>
                }/>
            </FormControl>}
            {(!stato.giaSocio && !stato.socio2020) && <Fragment>
                <MuiPickersUtilsProvider utils={LocalizedUtils}>
                    <DatePicker name={"dataNascita"} label="Data di nascita" format="D MMMM Y" disabled={stato.giaSocio||stato.socio2020} value={stato.dataNascita} size={"medium"} fullWidth onChange={handleDateChange} disableFuture openTo={"year"} required/>
                </MuiPickersUtilsProvider>
                <TextField name={"luogoNascita"} label={"Luogo di nascita"} disabled={stato.giaSocio||stato.socio2020} value={stato.luogoNascita} fullWidth={true} onChange={updateField} required/>
                <TextField name={"indirizzo"} label={"Indirizzo"} disabled={stato.giaSocio||stato.socio2020} value={stato.indirizzo} fullWidth={true} onChange={updateField} required/>
                <TextField id={"citta"} name={"citta"} label={"Città"} disabled={stato.giaSocio||stato.socio2020} value={stato.citta} fullWidth={true} onChange={updateField} required/>
                <TextField name={"email"} label={"E-mail (facoltativa)"} disabled={stato.giaSocio||stato.socio2020} value={stato.email} fullWidth={true} onChange={updateField}/>
            </Fragment>}
        </DialogContent>
        <DialogActions>
            <Button onClick={props.chiudi}>Annulla</Button>
            <Button id="persona-submit" type={"submit"}>Salva</Button>
        </DialogActions>
        </form>
    </Dialog>)
}

export default AddDialog
